<template>
  <div>
    <v-alert v-if="isSasaranPop" type="error" dark border="left" prominent>
      Peringatan ! Sekolah ini teridentifikasi sebagai sasaran dari Program Organisasi Penggerak.
    </v-alert>
    <v-card tile flat class="my-5">
      <v-card-text class="pa-0">
        <v-row no-gutters>
          <v-col cols="2">
            <div class="bg-kiri"></div>
          </v-col>
          <v-col cols="10" class="pa-5">
            <v-row dense>
              <v-col cols="12" md="9" sm="12">
                <h1 class="headline" v-if="isEdit"> <strong>Instruksi</strong> Pemeriksaan </h1>
                <h1 class="headline" v-else> <strong>Hasil</strong> Pemeriksaan </h1>
              </v-col>
              <v-col cols="12" md="3" sm="12" class="text-md-right">
                <template v-if="jenis === 'instruktur'">
                  <template v-if="Number($getDeepObj(detail, 'is_cadangan')) > -1">
                    <v-chip color="grey" class="mx-1" dark>{{
                      Number($getDeepObj(detail, 'is_cadangan')) === 1
                        ? 'Akselerasi 1'
                        : Number($getDeepObj(detail, 'is_cadangan')) === 2
                        ? 'Akselerasi 2'
                        : 'Reguler'
                    }}</v-chip>
                  </template>
                </template>
                <template v-else>
                  <template v-if="Number($getDeepObj(detail, 'is_cadangan')) > -1">
                    <v-chip color="grey" class="mx-1" dark>
                      {{ Number($getDeepObj(detail, 'is_cadangan')) >= 1 ? 'Cadangan' : 'Reguler' }}
                    </v-chip>
                  </template>
                </template>
                <v-chip :color="$getDeepObj(detail, 'status.color')" dark>{{
                  $getDeepObj(detail, 'status.keterangan')
                }}</v-chip>
              </v-col>
            </v-row>
            <p v-if="isEdit">
              Anda perlu memeriksa keabsahan dokumen yang dikirimkan oleh para kandidat Peserta
              {{ tipe[jenis].label }} Program Sekolah Penggerak, serta kesesuaiannya dengan data kandidat yang terekam
              oleh sistem
            </p>
            <v-row v-if="!isEdit || isDisable" dense>
              <v-col cols="12" md="4" sm="6">
                <v-list dense two-line outlined>
                  <v-list-item>
                    <v-list-item-icon
                      ><v-icon class="mt-3" color="indigo" size="40">mdi-account-lock</v-icon></v-list-item-icon
                    >
                    <v-list-item-content class="ml-n2">
                      <p class="indigo--text">Verifikator</p>
                      <h2 class="indigo--text">{{ $getDeepObj(detail, 'verifikator.data.nama') || '-' }}</h2>
                      <span class="indigo--text">
                        {{ $getDeepObj(detail, 'verifikator.data.email') || '-' }}
                      </span>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <statistik v-if="false" :value="statistik"></statistik>
    <v-card flat>
      <v-card-text>
        <v-alert
          v-if="$getDeepObj(detail, 'is_luar_sasaran')"
          icon="mdi-information-outline"
          text
          color="error"
          class="mb-0"
        >
          <v-row align="center" no-gutters>
            <v-col cols="12" md="9" class="grow">
              <strong>Pengawas bukan berasal dari Daerah Sasaran</strong>
            </v-col>
          </v-row>
        </v-alert>
        <div class="mb-3">
          <v-row v-if="detail && detail.lulus_tahap === 2">
            <v-col cols="12" class="my-auto">
              <h2 class="grey--text">Informasi Umum Kandidat Fasilitator</h2>
            </v-col>
          </v-row>
          <v-row v-else>
            <v-col cols="12" sm="12" md="6" class="my-auto">
              <h2 class="grey--text">Portofolio / CV</h2>
            </v-col>
            <v-col cols="12" md="6">
              <div class="body-1 warning--text text-right">
                <strong>{{ tipe[jenis].label }}</strong>
                <div>
                  <small class="warning--text text--darken-1" v-if="jenis === 'instruktur'">
                    {{ $getDeepObj(detail, 'm_unsur_psp.data.keterangan') }}
                  </small>
                </div>
              </div>
            </v-col>
          </v-row>
        </div>
        <v-divider />
        <!-- CV -->
        <v-list three-line class="pa-0 mb-4">
          <v-row dense>
            <v-col md="6" sm="12" cols="12">
              <v-list class="pa-2" outlined>
                <v-subheader class="subtitle-2 black--text ml-n3"><strong>PROFIL</strong> </v-subheader>
                <v-divider />
                <v-row dense no-gutters>
                  <v-col class="my-n1" v-for="(item, i) in profil" :key="i" v-bind="item.grid">
                    <v-list-item-content>
                      <div class="grey--text text-bold">
                        {{ item.title }}&nbsp;<span v-if="item.required" class="red--text">*</span>
                      </div>
                      <div>
                        <template v-if="item.subtitle">
                          <span class="subtitle-1" v-html="item.subtitle" />
                          <v-icon v-if="item.action" color="success" small dark @click="onCall"> mdi-whatsapp </v-icon>
                        </template>
                        <template v-else>
                          <span :class="['subtitle-1', item.required ? 'warning--text' : '']">
                            {{ item.required ? 'Belum dilengkapi' : '-' }}
                          </span>
                        </template>
                      </div>
                    </v-list-item-content>
                  </v-col>
                </v-row>
              </v-list>
            </v-col>
            <v-col md="6" sm="12" cols="12">
              <v-list class="pa-2" outlined>
                <v-subheader class="subtitle-2 black--text"><strong>DOKUMEN ADMINISTRASI</strong> </v-subheader>
                <v-divider />
                <v-row dense>
                  <template v-for="(item, i) in dokumen">
                    <v-col :key="i" md="12" sm="12" cols="12">
                      <v-list three-line>
                        <v-list-item>
                          <v-list-item-icon class="my-auto">
                            <v-icon color="red" dark left>mdi-file-pdf</v-icon>
                          </v-list-item-icon>
                          <v-list-item-content class="my-auto">
                            <v-row no-gutters>
                              <v-col cols="12" md="8" sm="12">
                                <div>{{ item.text }}</div>
                                <div class="info--text" v-if="[].includes(Number(item.value))" type="red">
                                  * Dokumen bersifat
                                </div>
                              </v-col>
                              <v-col cols="12" md="4" sm="12">
                                <v-btn
                                  depressed
                                  small
                                  :disabled="!item.url"
                                  :color="item.url ? 'primary' : 'warning'"
                                  :href="item.url"
                                  target="_blank"
                                >
                                  <v-icon left>mdi-eye</v-icon>Lihat berkas
                                </v-btn>
                              </v-col>
                            </v-row>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                      <v-divider v-if="i + 1 !== dokumen.length" />
                    </v-col>
                  </template>
                </v-row>
              </v-list>
            </v-col>
          </v-row>
        </v-list>
        <v-alert text color="info" v-if="isEdit && jenisBerkas !== 'berkas-mundur'" icon="mdi-information">
          <template v-if="detail && detail.lulus_tahap === 2">
            <h3 class="black--text">
              <b>Informasi Tambahan Tim Penilai</b>
            </h3>
            <p class="body-2 black--text mb-0">
              Setelah Anda menilai kelengkapan dokumen ini. Silahkan
              <strong>Tekan Tombol SIMPAN Pada Pojok Kanan Atas</strong> layar Anda. untuk memastikan Anda benar-benar
              menyelesaikan sesi penilaian ini.
            </p>
          </template>
          <template v-else>
            <h3 class="headline">
              <b>Informasi Tambahan:</b>
            </h3>
            <v-row align="center" no-gutters>
              <v-col cols="12" md="9" class="grow">
                Pastikan Bapak/Ibu Tim Verval untuk memperhatikan dan membaca Aturan Verval yang sudah kami siapkan
                untuk membantu memberikan keputusan Verval kandidat Sekolah Penggerak.
              </v-col>
              <v-spacer></v-spacer>
              <v-col class="shrink">
                <v-btn color="info" depressed @click="onPanduan">
                  Lihat Disini
                </v-btn>
              </v-col>
            </v-row>
            <v-divider class="my-4 info" style="opacity: 0.22"></v-divider>
            <div>
              Setelah Anda memeriksa kelengkapan dokumen ini, silahkan tekan tombol <b>SIMPAN</b> pada pojok kanan atas
              layar Anda.
            </div>
          </template>
        </v-alert>
        <v-list
          three-line
          class="pa-0 mb-4"
          v-if="detail && [6, 2, 3].includes(detail.k_verval_psp) && hasCatatanBefore"
        >
          <v-row dense>
            <v-col cols="12">
              <v-list class="pa-2" outlined>
                <v-list-item>
                  <v-list-item-content>
                    <v-row>
                      <v-col cols="12" sm="12" md="1" class="my-auto">
                        <v-avatar tile rounded>
                          <v-icon size="60">mdi-file-document-edit-outline</v-icon>
                        </v-avatar>
                      </v-col>
                      <v-col cols="12" sm="12" md="11">
                        <div class="black--text my-2 ml-1">
                          <h3>Catatan Verval Sebelumnya</h3>
                          <p class="body-2 mb-0" v-html="catatan || '-'"></p>
                        </div>
                      </v-col>
                    </v-row>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-col>
          </v-row>
        </v-list>

        <v-list three-line class="pa-0 mb-4">
          <v-list-item-content
            v-if="
              detail &&
                (detail.k_verval_psp === 3 ||
                  detail.k_verval_sehat === 3 ||
                  detail.k_verval_izin === 3 ||
                  detail.k_verval_mundur === 3)
            "
          >
            <v-row>
              <v-col cols="12" sm="12" md="1" class="my-auto">
                <v-avatar tile rounded>
                  <v-icon size="60">mdi-file-document-edit-outline</v-icon>
                </v-avatar>
              </v-col>
              <v-col cols="12" sm="12" md="11">
                <div class="black--text my-2 ml-1">
                  <h3>Pemeriksaan Dokumen</h3>
                  Berikan Penilaian pada kelengkapan dan keabsahan dokumen ini, Apakah semua dokumen sah dan sesuai
                  dengan data yang di inputkan kandidat?
                </div>
                <v-card flat :disabled="isDisable || !isEdit">
                  <v-row dense>
                    <template v-for="item in mBtnPilihan">
                      <v-col
                        v-if="isEdit ? $allow(item.akses, (detail && detail.policies) || false) : false"
                        :key="item.value"
                        cols="12"
                        md="4"
                        class="my-auto"
                      >
                        <v-btn
                          block
                          dark
                          :color="item.color"
                          :outlined="pilihan !== item.value"
                          @click="onSelected(item.value)"
                          style="background-color: white"
                        >
                          <v-icon small left>{{ item.icon }}</v-icon
                          >{{ item.label }}
                        </v-btn>
                      </v-col>
                    </template>
                  </v-row>
                </v-card>
                <div>
                  <template v-if="pilihan && !isDisable">
                    <div
                      class="py-4"
                      v-if="
                        ($isObject(schema[pilihan]) && detail.lulus_tahap === 2 && jenisBerkas !== 'berkas-mundur') ||
                          ['berkas-izin'].includes(jenisBerkas)
                      "
                    >
                      <div class="mt-1">
                        <base-form-generator :schema="[schema[pilihan]]" v-model="form" />
                      </div>
                    </div>
                    <div class="py-4" v-else-if="$isObject(schema[pilihan])">
                      <h4 class="black--text">
                        {{ schema[pilihan]['label'] }} {{ schema[pilihan]['unrequired'] ? '' : '*' }}
                      </h4>
                      <div class="mt-1">
                        <validation-provider
                          mode="passive"
                          :name="schema[pilihan]['label']"
                          :rules="schema[pilihan]['unrequired'] ? '' : 'required'"
                          v-slot="{ errors }"
                        >
                          <v-combobox
                            v-model="form['alasan']"
                            :search-input.sync="search"
                            :items="schema[pilihan]['items']"
                            :error-messages="errors"
                            label="Silakan memilih alasan pada pilihan atau buat alasan lainnya (ketik manual kemudian tekan enter)"
                            :hide-selected="jenisBerkas !== 'berkas-mundur'"
                            multiple
                            persistent-hint
                            small-chips
                            outlined
                            dense
                            single-line
                            hide-details
                            clearable
                          >
                            <template slot="item" slot-scope="data">
                              <p v-html="data.item.text"></p>
                            </template>
                            <template v-slot:no-data>
                              <v-list-item>
                                <v-list-item-content>
                                  <v-list-item-title>
                                    Alasan dengan kata kunci "<strong>{{ search }}</strong
                                    >" tidak ditemukan. Tekan tombol <kbd>enter</kbd> untuk membuat alasan Anda menjadi
                                    pilihan.
                                  </v-list-item-title>
                                </v-list-item-content>
                              </v-list-item>
                            </template>
                          </v-combobox>
                        </validation-provider>
                      </div>
                    </div>
                  </template>
                  <template v-if="$isObject(schema[pilihan]) && (!isEdit || isDisable)">
                    <b class="black--text">Catatan Verval*</b><br />
                    <v-card flat outlined>
                      <v-card-text v-html="catatan"></v-card-text>
                    </v-card>
                  </template>
                </div>
              </v-col>
            </v-row>
          </v-list-item-content>
          <v-list-item-content
            v-else-if="
              detail &&
                ([4, 5].includes(detail.k_verval_psp) ||
                  [4, 5].includes(detail.k_verval_sehat) ||
                  [4, 5].includes(detail.k_verval_mundur) ||
                  [4, 5].includes(detail.k_verval_izin))
            "
          >
            <v-row dense>
              <v-col cols="12">
                <v-list class="pa-2" outlined>
                  <v-list-item>
                    <v-list-item-content>
                      <v-row>
                        <v-col cols="12" sm="12" md="1" class="my-auto">
                          <v-avatar tile rounded>
                            <v-icon size="60">mdi-file-document-edit-outline</v-icon>
                          </v-avatar>
                        </v-col>
                        <v-col cols="12" sm="12" md="11">
                          <div class="black--text my-2 ml-1">
                            <h3>Catatan Hasil Pemeriksaan Dokumen</h3>
                            <p class="body-2 mb-0" v-html="catatan || '-'"></p>
                          </div>
                        </v-col>
                      </v-row>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-col>
            </v-row>
          </v-list-item-content>
        </v-list>
      </v-card-text>
    </v-card>
    <popup-preview-detail ref="view" :url="view.url || ''" :title="view.title || ''">
      <v-container fluid class="px-2">
        <v-card flat class="py-0">
          <v-alert color="red" text border="left" type="info">
            Pastikan nama dan data pada profil sesuai dengan dokumen yang telah di inputkan
          </v-alert>
          <v-list three-line class="px-2 my-n5">
            <v-row dense no-gutters>
              <v-col
                v-for="(item, i) in view.info"
                :key="i"
                :md="item.label === 'Keterangan' ? 12 : item.label === 'Alamat' ? 6 : 3"
                sm="12"
                cols="12"
              >
                <v-list-item-content>
                  <v-list-item-title class="subtitle-2 grey--text my-n1">{{ item.label }}</v-list-item-title>
                  <div class="subtitle-1 black--text" v-html="item.value" />
                </v-list-item-content>
              </v-col>
            </v-row>
          </v-list>
        </v-card>
      </v-container>
    </popup-preview-detail>
  </div>
</template>
<script>
import BaseFormGenerator from '@components/base/BaseFormGenerator';
import PopupPreviewDetail from '@components/popup/PreviewDetil';
import Statistik from '@/views/instansi/verval/component/Statistik';
import Panduan from './panduan';
import { ValidationProvider } from 'vee-validate';
export default {
  name: 'FormBerkas',
  components: { BaseFormGenerator, Statistik, PopupPreviewDetail, ValidationProvider },
  props: {
    masters: {
      default: () => {},
    },
    detail: {
      default: () => {},
    },
    id: {
      type: [Number, String],
      default: 0,
    },
    configs: {
      default: () => {},
    },
    berkas: {
      default: () => [],
    },
    angkatan: {
      type: Number,
      default: 1,
    },
    isEdit: {
      type: Boolean,
      default: true,
    },
    isDisable: {
      type: Boolean,
      default: false,
    },
    statistik: {
      type: Object,
      default: () => {},
    },
    initValue: {
      type: Object,
      default: () => null,
    },
    jenis: {
      type: String,
      default: () => 'kasek',
    },
    jenisBerkas: {
      type: String,
      default: () => '',
    },
  },
  mixins: [Panduan],

  data() {
    return {
      view: {},
      pilihan: null,
      search: null,
      form: {},
    };
  },

  computed: {
    tipe() {
      return {
        kasek: { key: 'kasek', label: 'Kepala Sekolah' },
        instruktur: { key: 'instruktur', label: 'Fasilitator' },
      };
    },

    hasCatatanBefore() {
      const revisi = (this.$getDeepObj(this.detail, 'psp_profil_proseses.data') || []).filter((proses) => {
        return [8, 17, 20].includes(proses.k_profil_proses_psp);
      });

      return revisi && revisi.length > 0;
    },

    catatan() {
      const configs = {
        'berkas-sehat': { k_proses: 17, type: 'json' },
        'berkas-izin': { k_proses: 20, type: 'text' },
        'berkas-mundur': { k_proses: 23, type: 'json' },
      };
      const config = configs[this.jenisBerkas] || false;

      if (config) {
        const revisi = (this.$getDeepObj(this.detail, 'psp_profil_proseses.data') || []).filter(
          (proses) => +proses.k_profil_proses_psp === config.k_proses
        );
        let catatan = (revisi[0] && revisi[0]['catatan']) || '-';
        if (config.type === 'json') {
          catatan = JSON.parse((revisi[0] && revisi[0]['catatan']) || `[]`);
        }

        return this.$isArray(catatan)
          ? (catatan || []).map((item) => (this.$isObject(item) ? `- ${item.value}` : `- ${item}`)).join('<br/>')
          : catatan;
      }

      const alasan = JSON.parse(this.$getDeepObj(this.detail, 'alasan') || `[]`);
      return (alasan || []).map((item) => (this.$isObject(item) ? item.value : item)).join('<br/>');
    },

    profil() {
      const item = Object.assign({}, this.detail);
      let lokasiTugas = '';
      const ptkSekolah = this.$getDeepObj(item, 'ptk.data.ptk_sekolah') || null;
      const ptkTugas = this.$getDeepObj(item, 'ptk.data.ptk_tugas') || null;
      const sekolah = this.$getDeepObj(item, 'ptk.data.sekolah') || null;
      const instansi = this.$getDeepObj(item, 'ptk.data.instansi') || null;
      const ptkDapodik = this.$getDeepObj(item, 'meta.ptk');
      const ptkTugasDapodik = this.$getDeepObj(ptkDapodik, 'ptk_tugases') || [];
      const kUnsurPsp = this.$getDeepObj(item, 'k_unsur_psp') || null;
      const kKurikulumPsp = this.$getDeepObj(item, 'k_kurikulum_psp') || null;
      const descTugas = ptkTugasDapodik.map((item) => {
        return `
            ${this.$getDeepObj(item, 'm_tugas.keterangan')}
            ${this.$getDeepObj(item, 'sekolah.nama')}
            (${this.$getDeepObj(item, 'sekolah.npsn')}) pada <br/>
            ${this.$getDeepObj(item, 'sekolah.m_kota.keterangan')} ,
            ${this.masters['propinsi'][this.$getDeepObj(item, 'sekolah.k_propinsi')] || '-'}<br/>
            <div>TMT Tambahan: ${this.$localDate(this.$getDeepObj(item, 'tmt_tambahan'))}</div>
            <div>Periode Tugas: ${this.$getDeepObj(item, 'periode_tambahan') || '-'}</div>
      `;
      });

      if (ptkSekolah) {
        lokasiTugas = this.$getDeepObj(ptkSekolah, 'data.sekolah.data.nama') || '-';
      } else if (sekolah) {
        lokasiTugas = this.$getDeepObj(sekolah, 'data.nama') || '-';
      } else if (ptkTugas) {
        lokasiTugas = this.$getDeepObj(ptkTugas, 'data.instansi.data.nama') || '-';
      } else {
        lokasiTugas = instansi || '-';
      }

      let detail = {
        kasek: [
          {
            key: 'nama',
            title: 'Nama Lengkap',
            subtitle: `<strong>${this.$getDeepObj(item, 'ptk.data.nama') || ''}</strong>`,
            grid: { md: 6, sm: 12, cols: 12 },
          },
          {
            key: 'nik',
            title: 'NIK',
            required: true,
            subtitle: `${this.$getDeepObj(item, 'nik') || ''}`,
            grid: { md: 6, sm: 12, cols: 12 },
          },
          {
            key: 'no_telp',
            title: 'Nomor Telepon',
            subtitle: `${this.$getDeepObj(item, 'ptk.data.no_hp') || ''}`,
            grid: { md: 6, sm: 12, cols: 12 },
          },
          {
            key: 'no_wa',
            required: true,
            title: 'Nomor Telepon (Terhubung Whatsapp)',
            subtitle: `${this.$getDeepObj(item, 'no_wa') || ''}`,
            grid: { md: 6, sm: 12, cols: 12 },
            action: 'call',
          },
          {
            key: 'email',
            required: true,
            title: 'Alamat Surel',
            subtitle: `${this.$getDeepObj(item, 'ptk.data.email') || ''}`,
            grid: { md: 6, sm: 12, cols: 12 },
          },
          {
            key: 'alt_email',
            title: 'Alamat Surel (Untuk Kontak)',
            subtitle: `${this.$getDeepObj(item, 'ptk.data.alt_email') || ''}`,
            grid: { md: 6, sm: 12, cols: 12 },
          },
          {
            key: 'alamat',
            required: true,
            title: 'Alamat',
            subtitle:
              this.$getDeepObj(item, 'alamat') &&
              this.$getDeepObj(item, 'k_propinsi') &&
              this.$getDeepObj(item, 'k_kota')
                ? [
                    this.$getDeepObj(item, 'alamat'),
                    `<br /> ${this.$getDeepObj(item, 'm_kota.data.keterangan')} - ${this.$getDeepObj(
                      item,
                      'm_propinsi.data.keterangan'
                    )}`,
                  ].join('')
                : '',
            grid: { md: 12, sm: 12, cols: 12 },
          },
          {
            key: 'tmp_lahir',
            title: 'Tempat Lahir',
            subtitle: `${this.$getDeepObj(item, 'ptk.data.tmp_lahir') || ''}`,
            grid: { md: 6, sm: 12, cols: 12 },
          },
          {
            key: 'tgl_lahir',
            title: 'Tanggal Lahir',
            subtitle: `${this.$localDate(this.$getDeepObj(item, 'ptk.data.tgl_lahir')) || ''}`,
            grid: { md: 6, sm: 12, cols: 12 },
          },
          {
            key: 'usia',
            title: 'Usia (mengacu Desember 2022)',
            subtitle: [
              `<span class='${Number(this.$getDeepObj(item, 'usia')) >= 56 ? 'red--text' : ''}'>`,
              `${this.$getDeepObj(item, 'usia') || '-'} Tahun`,
              `</span>`,
            ].join(''),
            grid: { md: 6, sm: 12, cols: 12 },
          },
          {
            key: 'kelamin',
            title: 'Jenis Kelamin',
            subtitle: `${this.$fGender(this.$getDeepObj(item, 'ptk.data.kelamin')) || ''}`,
            grid: { md: 6, sm: 12, cols: 12 },
          },
          {
            key: 'instansi',
            title: 'Asal Sekolah',
            subtitle: this.$getDeepObj(item, 'sekolah.data.nama') || '',
            grid: { md: 6, sm: 12, cols: 12 },
          },
          {
            key: 'npsn',
            title: 'Nomor Pokok Sekolah Nasional (NPSN)',
            subtitle: this.$getDeepObj(item, 'sekolah.data.npsn') || '',
            grid: { md: 6, sm: 12, cols: 12 },
          },
          {
            key: 'jenjang',
            title: 'Jenjang',
            subtitle: this.$getDeepObj(item, 'sekolah.data.m_jenjang.data.singkat') || '',
            grid: { md: 6, sm: 12, cols: 12 },
          },
          {
            key: 'k_kasek_lama_psp',
            required: true,
            title: 'Lama menjabat sebagai Kepala Satuan Pendidikan',
            subtitle: `${this.$getDeepObj(item, 'm_profil_opsi_psp_kasek_lama.data.keterangan') || ''}`,
            grid: { md: 6, sm: 12, cols: 12 },
          },
          {
            key: 'k_kasek_sisa_psp',
            required: true,
            title: 'Sisa masa tugas sebagai kepala satuan pendidikan',
            subtitle: `<span class="${
              this.$getDeepObj(item, 'k_kasek_sisa_psp') === 16001 ? 'error--text' : ''
            }">${this.$getDeepObj(item, 'm_profil_opsi_psp_kasek_sisa.data.keterangan') || ''}</span>`,
            grid: { md: 6, sm: 12, cols: 12 },
          },
          {
            key: 'pendidikan_instansi',
            required: true,
            title: 'Nama Instansi Pendidikan Terakhir',
            subtitle: `${this.$getDeepObj(item, 'pendidikan_instansi') || ''}`,
            grid: { md: 6, sm: 12, cols: 12 },
          },
          {
            key: 'k_pendidikan_bidang_psp',
            required: true,
            title: 'Bidang Pendidikan Terakhir',
            subtitle: `${this.$getDeepObj(item, 'm_profil_opsi_psp_pendidikan_bidang.data.keterangan') || ''}`,
            grid: { md: 6, sm: 12, cols: 12 },
          },
          {
            key: 'sekolah_id',
            title: 'Satminkal',
            subtitle: `
              ${this.$getDeepObj(item, 'ptk.data.ptk_sekolah.data.sekolah.data.nama') || ''}
              (${this.$getDeepObj(item, 'ptk.data.ptk_sekolah.data.sekolah.data.npsn') || ''})<br/>
              ${this.masters['kota'][this.$getDeepObj(item, 'ptk.data.ptk_sekolah.data.sekolah.data.k_kota')] || '-'},
              ${this.masters['propinsi'][this.$getDeepObj(item, 'ptk.data.ptk_sekolah.data.sekolah.data.k_propinsi')] ||
                '-'}
              `,
            grid: { md: 6, sm: 12, cols: 12 },
          },
          {
            key: 'tugas_id',
            title: 'Tugas Tambahan',
            subtitle:
              [
                this.$getDeepObj(item, 'm_tugas.data.keterangan'),
                `
                ${this.$getDeepObj(item, 'sekolah.data.nama')}
                (${this.$getDeepObj(item, 'sekolah.data.npsn')})
                `,
              ].join(' pada ') +
              `<br/>
             ${this.masters['kota'][this.$getDeepObj(item, 'sekolah.data.k_kota')] || '-'} ,
             ${this.masters['propinsi'][this.$getDeepObj(item, 'sekolah.data.k_propinsi')] || '-'}
            `,
            grid: { md: 6, sm: 12, cols: 12 },
          },
          {
            key: 'pendidikan_jurusan',
            required: true,
            title: 'Jurusan Pendidikan Terakhir',
            subtitle: `${this.$getDeepObj(item, 'pendidikan_jurusan') || ''}`,
            grid: { md: 6, sm: 12, cols: 12 },
          },
          {
            key: 'tmt_tambahan',
            title: 'TMT Tambahan',
            subtitle: this.$localDate(this.$getDeepObj(item, 'ptk.data.ptk_tugas.data.tmt_tambahan')) || '-',
            grid: { md: 6, sm: 12, cols: 12 },
          },
          {
            key: 'periode_tambahan',
            title: 'Periode Tugas Tambahan',
            subtitle: this.$getDeepObj(item, 'ptk.data.ptk_tugas.data.periode_tambahan')
              ? `${this.$getDeepObj(item, 'ptk.data.ptk_tugas.data.periode_tambahan')} Periode`
              : '-',
            grid: { md: 6, sm: 12, cols: 12 },
          },
          {
            key: 'sekolah_id_dapodik',
            title: 'Satminkal (Dapodik)',
            subtitle: `
              ${this.$getDeepObj(item, 'meta.ptk.ptk_sekolah.sekolah.nama') || ''}
              (${this.$getDeepObj(item, 'meta.ptk.ptk_sekolah.sekolah.npsn') || ''})<br/>
              ${this.masters['kota'][this.$getDeepObj(item, 'meta.ptk.ptk_sekolah.sekolah.k_kota')] || '-'},
              ${this.masters['propinsi'][this.$getDeepObj(item, 'meta.ptk.ptk_sekolah.sekolah.k_propinsi')] || '-'}
              `,
            grid: { md: 12, sm: 12, cols: 12 },
          },
          {
            key: 'tugas_id_dapodik',
            title: 'Tugas Tambahan (Dapodik)',
            subtitle: descTugas.join(''),
            grid: { md: 12, sm: 12, cols: 12 },
          },
        ],
        instruktur: [
          {
            key: 'nama',
            title: 'Nama Lengkap',
            subtitle: `<strong>${this.$getDeepObj(item, 'ptk.data.nama') || ''}</strong>`,
            grid: { md: 6, sm: 12, cols: 12 },
          },
          {
            key: 'nik',
            title: 'NIK (sesuai KTP)',
            subtitle: this.$getDeepObj(item, 'nik') || '',
            grid: { md: 6, sm: 12, cols: 12 },
          },
          {
            key: 'tmp_lahir',
            title: 'Tempat Lahir',
            subtitle: this.$getDeepObj(item, 'ptk.data.tmp_lahir') || '-',
            grid: { md: 6, sm: 12, cols: 12 },
          },
          {
            key: 'tgl_lahir',
            title: 'Tanggal Lahir',
            subtitle: this.$localDate(this.$getDeepObj(item, 'ptk.data.tgl_lahir') || '-'),
            grid: { md: 6, sm: 12, cols: 12 },
          },
          {
            key: 'usia',
            title: 'Usia',
            subtitle: [`<span>`, `${this.$getDeepObj(item, 'usia') || '-'}`, `</span>`].join(''),
            grid: { md: 6, sm: 12, cols: 12 },
          },
          {
            key: 'email',
            title: 'Alamat Surel',
            subtitle: this.$getDeepObj(item, 'ptk.data.email') || '-',
            grid: { md: 6, sm: 12, cols: 12 },
          },
          {
            key: 'no_telp',
            title: 'Nomor Telepon',
            subtitle: this.$getDeepObj(item, 'ptk.data.no_hp') || '-',
            grid: { md: 6, sm: 12, cols: 12 },
          },
          {
            key: 'no_wa',
            title: 'Nomor Telepon (terhubung WhatsApp)',
            subtitle: this.$getDeepObj(item, 'no_wa') || '-',
            grid: { md: 6, sm: 12, cols: 12 },
          },
          {
            key: 'alamat_ktp',
            title: 'Alamat (sesuai KTP)',
            subtitle: this.$getDeepObj(item, 'alamat_ktp') || '-',
            grid: { cols: 12 },
          },
          {
            key: 'k_propinsi_ktp',
            title: 'Provinsi (sesuai KTP)',
            subtitle: this.$getDeepObj(item, 'm_propinsi_ktp.data.keterangan') || '-',
            grid: { md: 6, sm: 12, cols: 12 },
          },
          {
            key: 'k_kota_ktp',
            title: 'Kota/Kabupaten (sesuai KTP)',
            subtitle: this.$getDeepObj(item, 'm_kota_ktp.data.keterangan') || '-',
            grid: { md: 6, sm: 12, cols: 12 },
          },
          {
            key: 'alamat',
            title: 'Alamat Tinggal Sekarang',
            subtitle: this.$getDeepObj(item, 'alamat') || '-',
            grid: { cols: 12 },
          },
          {
            key: 'k_propinsi',
            title: 'Provinsi',
            subtitle: this.$getDeepObj(item, 'm_propinsi.data.keterangan') || '-',
            grid: { md: 6, sm: 12, cols: 12 },
          },
          {
            key: 'k_kota',
            title: 'Kota/Kabupaten',
            subtitle: this.$getDeepObj(item, 'm_kota.data.keterangan') || '-',
            grid: { md: 6, sm: 12, cols: 12 },
          },
          {
            key: 'kodepos',
            title: 'Kodepos',
            subtitle: this.$getDeepObj(item, 'kodepos') || '-',
            grid: { cols: 12 },
          },
          {
            key: 'k_kasek_sisa_psp',
            title: 'Pengalaman melakukan pendampingan peningkatan mutu pendidikan',
            subtitle: `<span class="${
              [30001, 30002].indexOf(Number(item.k_pendampingan_psp)) > -1 ? 'red--text' : ''
            }">${this.$getDeepObj(item, 'm_profil_opsi_psp_pendampingan.data.keterangan') || '-'}</span>`,
            grid: { md: 6, sm: 12, cols: 12 },
          },
          {
            key: 'k_kualifikasi',
            title: 'Pendidikan terakhir',
            subtitle: this.$getDeepObj(item, 'm_kualifikasi.data.keterangan') || '-',
            grid: { md: 6, sm: 12, cols: 12 },
          },
          {
            key: 'pendidikan_instansi',
            title: 'Nama instansi pendidikan terakhir',
            subtitle: this.$getDeepObj(item, 'pendidikan_instansi') || '-',
            grid: { md: 6, sm: 12, cols: 12 },
          },
          {
            key: 'k_pendidikan_bidang_psp',
            title: 'Bidang Pendidikan Terakhir',
            subtitle: this.$getDeepObj(item, 'm_profil_opsi_psp_pendidikan_bidang.data.keterangan') || '-',
            grid: { md: 6, sm: 12, cols: 12 },
          },
          {
            key: 'pendidikan_jurusan',
            title: 'Jurusan',
            subtitle: this.$getDeepObj(item, 'pendidikan_jurusan') || '-',
            grid: { cols: 12 },
          },
          {
            key: 'k_unsur_psp',
            title: 'Unsur',
            subtitle: this.$getDeepObj(item, 'm_unsur_psp.data.keterangan') || '-',
            grid: { cols: 12, sm: 12, md: 6 },
          },
          {
            key: 'lokasi_tugas',
            title: 'Lokasi Tugas',
            subtitle: lokasiTugas || '-',
            grid: { cols: 12, sm: 12, md: 6 },
          },
        ],
        berkas: [
          {
            key: 'nama',
            title: 'Nama Lengkap',
            subtitle: `<strong>${this.$getDeepObj(item, 'ptk.data.nama') || ''}</strong>`,
            grid: { md: 6, sm: 12, cols: 12 },
          },
          {
            key: 'nik',
            title: 'NIK (sesuai KTP)',
            subtitle: this.$getDeepObj(item, 'nik') || '',
            grid: { md: 6, sm: 12, cols: 12 },
          },
          {
            key: 'tmp_lahir',
            title: 'Tempat Lahir',
            subtitle: this.$getDeepObj(item, 'ptk.data.tmp_lahir') || '-',
            grid: { md: 6, sm: 12, cols: 12 },
          },
          {
            key: 'tgl_lahir',
            title: 'Tanggal Lahir',
            subtitle: this.$localDate(this.$getDeepObj(item, 'ptk.data.tgl_lahir') || '-'),
            grid: { md: 6, sm: 12, cols: 12 },
          },
          {
            key: 'usia',
            title: 'Usia',
            subtitle: [
              `<span class='${
                Number(this.$getDeepObj(item, 'usia')) >= 57 && this.jenis === 'kasek' ? 'red--text' : ''
              }'>`,
              `${this.$getDeepObj(item, 'usia') || '-'}`,
              `</span>`,
            ].join(''),
            grid: { md: 6, sm: 12, cols: 12 },
          },
          {
            key: 'email',
            title: 'Alamat Surel',
            subtitle: this.$getDeepObj(item, 'ptk.data.email') || '-',
            grid: { md: 6, sm: 12, cols: 12 },
          },
          {
            key: 'no_telp',
            title: 'Nomor Telepon',
            subtitle: this.$getDeepObj(item, 'ptk.data.no_hp') || '-',
            grid: { md: 6, sm: 12, cols: 12 },
          },
          {
            key: 'no_wa',
            title: 'Nomor Telepon (terhubung WhatsApp)',
            subtitle: this.$getDeepObj(item, 'no_wa') || '-',
            grid: { md: 6, sm: 12, cols: 12 },
          },
          {
            key: 'alamat_ktp',
            title: 'Alamat (sesuai KTP)',
            subtitle: this.$getDeepObj(item, 'alamat_ktp') || '-',
            grid: { cols: 12 },
          },
          {
            key: 'k_propinsi_ktp',
            title: 'Provinsi (sesuai KTP)',
            subtitle: this.$getDeepObj(item, 'm_propinsi_ktp.data.keterangan') || '-',
            grid: { md: 6, sm: 12, cols: 12 },
          },
          {
            key: 'k_kota_ktp',
            title: 'Kota/Kabupaten (sesuai KTP)',
            subtitle: this.$getDeepObj(item, 'm_kota_ktp.data.keterangan') || '-',
            grid: { md: 6, sm: 12, cols: 12 },
          },
          {
            key: 'alamat',
            title: 'Alamat Tinggal Sekarang',
            subtitle: this.$getDeepObj(item, 'alamat') || '-',
            grid: { cols: 12, md: 6, sm: 12 },
          },
        ],
      };

      if (this.jenis === 'instruktur') {
        const daerah = [
          {
            key: 'instansi_k_propinsi',
            title: 'Provinsi Bertugas Saat Ini',
            subtitle: this.$getDeepObj(item, 'm_propinsi_instansi.data.keterangan') || '-',
            grid: { cols: 12, md: 6, sm: 12 },
          },
          {
            key: 'instansi_k_kota',
            title: 'Kabupaten/Kota Bertugas Saat Ini',
            subtitle: this.$getDeepObj(item, 'm_kota_instansi.data.keterangan') || '-',
            grid: { cols: 12, md: 6, sm: 12 },
          },
        ];

        const profesi = [
          {
            key: 'instansi_profesi',
            title: 'Profesi/pekerjaan saat ini',
            subtitle: this.$getDeepObj(item, 'profesi') || '-',
            grid: { cols: 12, md: 6, sm: 12 },
          },
          {
            key: 'instansi_nama',
            title: 'Nama Instansi',
            subtitle: this.$getDeepObj(item, 'instansi_nama') || '-',
            grid: { cols: 12, md: 6, sm: 12 },
          },
        ];

        if (Number(this.$getDeepObj(item, 'm_unsur_psp.data.is_umum') || 0) === 1) {
          detail.instruktur = detail.instruktur.concat(profesi);
        }

        if ([10, 22, 23, 25].includes(Number(kUnsurPsp)) && [17099, 17010].includes(Number(kKurikulumPsp))) {
          if (Number(kKurikulumPsp) === 17099) {
            detail.instruktur.push({
              key: 'kurikulum_lain',
              title: 'Jenis Kurikulum Lain',
              subtitle: this.$getDeepObj(item, 'kurikulum_lain') || '-',
              grid: { cols: 12, md: 6, sm: 12 },
            });
          } else {
            detail.instruktur.push({
              key: 'k_kurikulum_internasional_psp',
              title: 'K13 Plus Kurikulum Internasional',
              subtitle: this.$getDeepObj(item, 'm_profil_opsi_psp_kurikulum_internasional.data.keterangan') || '-',
              grid: { cols: 12, md: 6, sm: 12 },
            });
          }
        }

        if ([21].includes(Number(kUnsurPsp))) {
          detail.instruktur.push({
            key: 'k_jenjang_pengawas_psp',
            title: 'Jenjang Satuan Pendidikan Penugasan',
            subtitle: this.$getDeepObj(item, 'm_profil_opsi_psp_jenjang_pengawas.data.keterangan') || '-',
            grid: { cols: 12, md: 6, sm: 12 },
          });
        }
        detail.instruktur = detail.instruktur.concat(daerah);
      }

      if (this.$getDeepObj(this.detail, 'lulus_tahap') === 2) {
        return detail['berkas'];
      }

      return detail[this.jenis] || [];
    },

    dokumen() {
      let berkas = this.berkas.map((item) => {
        return {
          text: this.$getDeepObj(item, 'm_profil_berkas_psp.data.keterangan'),
          singkat: this.$getDeepObj(item, 'm_profil_berkas_psp.data.singkat'),
          value: item.psp_profil_berkas_id,
          url: item.url_berkas,
        };
      });

      if (this.$getDeepObj(this.detail, 'meta.ajuan'))
        berkas.push({
          text: 'Pakta Integritas',
          singkat: 'pakta',
          value: this.$getDeepObj(this.detail, 'meta.ajuan.psp_peserta_ajuan_id'),
          url: this.$getDeepObj(this.detail, 'meta.ajuan.url_pakta'),
        });
      return berkas || [];
    },

    schema() {
      if (this.jenisBerkas === 'berkas-mundur') {
        return {
          1: {
            label: 'Alasan ajuan ditolak',
            items: this.$mapForMaster(this.masters['alasan_verval'] && this.masters['alasan_verval']['tolak_komitmen']),
          },
          3: {
            label: 'Alasan ajuan butuh diperbaiki',
            items: this.$mapForMaster(
              this.masters['alasan_verval'] && this.masters['alasan_verval']['perbaikan_komitmen']
            ),
          },
        };
      }

      if (this.jenisBerkas === 'berkas-sehat') {
        return {
          3: {
            label: 'Alasan ajuan butuh diperbaiki',
            items: this.$mapForMaster(this.masters['alasan_verval'] && this.masters['alasan_verval']['perbaikan']),
          },
        };
      }

      return {
        1: {
          label: 'Alasan ajuan ditolak',
          items: this.$mapForMaster(this.masters['alasan_verval'] && this.masters['alasan_verval']['tolak']),
        },
        2:
          this.detail.gelombang === 3
            ? {
                label: 'Catatan Setuju',
                unrequired: true,
                items: this.$mapForMaster(this.masters['alasan_verval'] && this.masters['alasan_verval']['setuju']),
              }
            : {
                type: 'VTextarea',
                name: 'alasan',
                label: 'Catatan Setuju',
                labelColor: 'black',
                placeholder: 'Tuliskan alasan verval setuju',
                hint: '',
                grid: { cols: 12, md: 12 },
                required: false,
                outlined: true,
                singleLine: true,
              },
        3: {
          label: 'Alasan ajuan butuh diperbaiki',
          items: this.$mapForMaster(this.masters['alasan_verval'] && this.masters['alasan_verval']['perbaikan']),
        },
        4: {
          type: 'VTextarea',
          name: 'alasan',
          label: 'Catatan Perbaikan',
          labelColor: 'black',
          placeholder: 'Tuliskan alasan verval di tolak',
          hint: 'wajib diisi',
          grid: { cols: 12, md: 12 },
          required: true,
          outlined: true,
          singleLine: true,
        },
      };
    },

    mBtnPilihan() {
      const isLulusTahap2 = this.detail && this.detail.lulus_tahap === 2;
      const berkas = this.jenisBerkas || 'berkas';
      const options = {
        setuju: {
          label: isLulusTahap2 || ['berkas-izin', 'berkas-mundur'].includes(berkas) ? 'Setujui Dokumen' : 'Diterima',
          icon: 'mdi-check',
          color: 'success',
          value: 2,
          akses: `psp-${this.jenis === 'instruktur' ? 'pelatih-ahli' : 'peserta'}-${berkas}.setuju`,
        },
        revisi: {
          label:
            isLulusTahap2 || ['berkas-izin', 'berkas-mundur'].includes(berkas)
              ? 'Perlu Perbaikan'
              : 'Diterima Dengan Perbaikan',
          icon: 'mdi-pencil',
          color: 'warning',
          value: berkas === 'berkas-izin' ? 4 : 3,
          akses: `psp-${this.jenis === 'instruktur' ? 'pelatih-ahli' : 'peserta'}-${berkas}.tolak-revisi`,
        },
        tolak: {
          label: 'Ditolak',
          icon: 'mdi-close',
          color: 'red',
          value: 1,
          akses: `psp-${this.jenis === 'instruktur' ? 'pelatih-ahli' : 'peserta'}-${berkas}.tolak`,
        },
      };

      return (isLulusTahap2 && berkas !== 'berkas-mundur') || berkas === 'berkas-izin'
        ? [options.setuju, options.revisi]
        : [options.setuju, options.revisi, options.tolak];
    },

    isSasaranPop() {
      return this.$getDeepObj(this, 'detail.meta.is_sasaran_pop') || false;
    },
  },

  methods: {
    getValue() {
      return { pilihan: this.pilihan, id: this.id, alasan: (this.form && this.form.alasan) || '' };
    },

    reset() {
      this.pilihan = null;
      this.$set(this, 'form', {});
    },

    onDetail(item) {
      let info = [];

      // filter field yang membutuhkan nama
      if (
        ['ktp', 'ref_atasan', 'rekomendasi', 'ref_komunitas', 'ref_teman', 'dukungan', 'pernyataan'].indexOf(
          item.singkat
        ) > -1
      ) {
        info.push({
          label: 'Nama',
          value: this.$getDeepObj(this.detail, 'ptk.data.nama') || '',
        });
      }

      // filter field yang membutuhkan NIK
      if (['ktp'].indexOf(item.singkat) > -1) {
        info.push({
          label: 'NIK',
          value: this.$getDeepObj(this, 'detail.nik') || '',
        });
      }

      // filter field yang membutuhkan alamat
      if (['ktp'].indexOf(item.singkat) > -1) {
        info.push({
          label: 'Alamat',
          value: this.$getDeepObj(this, 'detail.alamat') || '',
        });
      }

      if (['pendukung'].indexOf(item.singkat) > -1) {
        info.push({
          label: 'Nama',
          value: this.$getDeepObj(this, 'detail.ptk.nama') || '-',
        });

        info.push({
          label: 'NIK',
          value: this.$getDeepObj(this, 'detail.nik') || '-',
        });
        info.push({
          label: 'Alamat',
          value: this.$getDeepObj(this, 'detail.ptk.alamat') || '-',
        });
        info.push({
          label: 'Tempat Tanggal Lahir',
          value: `${this.$getDeepObj(this, 'detail.ptk.tmp_lahir') || '-'} ${this.$localDate(
            this.$getDeepObj(this, 'detail.ptk.tgl_lahir'),
            true,
            false
          )}`,
        });
        info.push({
          label: 'Pendidikan',
          value: this.$getDeepObj(this, 'detail.m_kualifikasi.keterangan') || '-',
        });
        info.push({
          label: 'Jurusan',
          value: this.$getDeepObj(this, 'detail.jurusan') || '-',
        });

        info.push({
          label: 'Instansi',
          value: this.$getDeepObj(this, 'detail.instansi') || '-',
        });
      }

      if (['dukungan', 'rekomendasi', 'ref_komunitas'].indexOf(item.singkat) > -1) {
        info.push({
          label: 'NIP/NUPTK',
          value: this.$getDeepObj(this, 'detail.ptk.nip') || this.$getDeepObj(this, 'detail.ptk.nuptk') || '-',
        });
        info.push({
          label: 'Jabatan',
          value: this.$getDeepObj(this, 'detail.m_jabatan_gpm.keterangan') || '-',
        });
      }

      if (['ref_komunitas', 'rekomendasi', 'ref_atasan', 'ref_teman'].indexOf(item.singkat) > -1) {
        // info.push({
        //   label: 'Instansi',
        //   value: this.$getDeepObj(this, 'detail.sekolah.nama') || this.$getDeepObj(this, 'detail.ptk.instansi') || '-',
        // })
        info.push({
          label: 'Keterangan',
          value: `
            <ul>
                <li>Pastikan nama yang direkomendasikan adalah <b>${this.$getDeepObj(this, 'detail.ptk.nama')}</b></li>
                <li>Pastikan dokumen <b>ditandatangani</b> pemberi rekomendasi</li>
            </ul>`,
        });
      }

      if (['dukungan'].indexOf(item.singkat) > -1) {
        info.push({
          label: 'Keterangan',
          value: `
            <ul>
                <li>Pastikan surat dukungan di tujukan kepada  <b>${this.$getDeepObj(
                  this,
                  'detail.ptk.nama'
                )}</b> yang tertera pada dokumen</li>
                <li>Pastikan dokumen <b>ditandatangani</b> pemberi dukungan</li>
            </ul>`,
        });
      }

      this.$set(this.view, 'url', item.url);
      this.$set(this.view, 'title', item.text);
      this.$set(this.view, 'info', info);

      this.$nextTick(() => {
        this.$refs.view.open();
      });
    },

    onCall() {
      const url = `https://wa.me/62${Number(this.$getDeepObj(this.detail, 'no_wa'))}`;
      window.open(url, '_blank');
    },

    initForm(value) {
      this.$set(this, 'pilihan', (value && value.pilihan) || null);
    },

    onSelected(value) {
      // set
      this.$set(this, 'pilihan', value);
      this.$set(this.form, 'alasan', '');

      if (Number(value) === 2 || this.isDisable || !this.isEdit) return;

      // notifikasi untuk pilihan selain setuju
      const msg = {
        1: `<p class="subtitle-1 mb-0 black--text">Mohon Jelaskan secara spesifik dan rinci mengapa kandidat ditolak secara permanen</p>`,
        3: `<p class="subtitle-1 mb-0 black--text">Mohon Jelaskan perbaikan yang harus dilakukan secara spesifik dan rinci</p>`,
        4: `<p class="subtitle-1 mb-0 black--text">Mohon Jelaskan perbaikan yang harus dilakukan secara spesifik dan rinci</p>`,
      };
      this.$notifikasi(msg[this.pilihan], 'Informasi', {
        avatarColor: '#bbdefb',
        iconColor: 'info',
        btnColor: 'info',
      });
    },

    onPanduan() {
      const msg = this.jenis === 'instruktur' ? this.panduanPa : this.panduanKs;
      this.$notifikasi(msg, 'Informasi & Perbaikan Proses Verval', {
        withIcon: false,
        btnColor: 'info',
      });
    },
  },
  watch: {
    initValue: 'initForm',
  },
};
</script>
<style scoped>
.bg-kiri {
  background: #bbdefb;
  height: 100%;
}
</style>
